import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Fab from "@mui/material/Fab";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import ForumIcon from "@mui/icons-material/Forum";
import { Button } from "../Button";
import styled from "@mui/material/styles/styled";
import { useMediaQuery, useTheme } from "@mui/material";
const StyleWrapper = styled(Box)(({ theme }) => {
    return {
        margin: "0px auto",
        paddingBottom: 50,
        ".MuiPaper-root": {
            border: "none",
            boxShadow: "0 2px 4px 0 #e5e5e5, 0 1px 2px 0 #bdbdbd",
        },
        ".MuiTabs-flexContainer": {
            justifyContent: "space-around",
        },
        ".MuiCardContent-root .MuiButtonBase-root": {
            minWidth: "13%",
            background: "#fff !important",
            color: "#162242",
        },
        ".MuiTabs-indicator": {
            backgroundColor: "#162242",
        },
        ".MuiTabs-scroller": {
            borderBottom: "1px solid #999999",
        },
        // ".MuiPaper-root": {
        //   padding: 10,
        // },
        ".product-wrapper_title span": {
            fontFamily: "Lato",
            fontSize: 42,
            textTransform: "uppercase",
        },
        "#product-wrapper_component": {
            minHeight: "40vh",
        },
        ".product-wrapper_footer": {
            background: "#f7f7f7",
            borderTop: "1px solid #bdbdbd",
            padding: 10,
            justifyContent: "space-between",
            textAlign: "right",
        },
        p: {
            margin: 0,
        },
        ".product-wrapper_footer-text": {
            margin: 0,
            fontFamily: "Roboto",
            fontSize: 14,
            fontWeight: "normal",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.14,
            whiteSpace: "pre",
            letterSpacing: "normal",
            color: "#333333",
            padding: "2px 0",
        },
        ".product-wrapper-header .MuiTabs-flexContainer .MuiButtonBase-root": {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        },
        ".need-help-wrapper": {
            display: "flex",
            gap: 10,
            b: {
                fontSize: 14,
                fontWeight: 700,
            },
        },
        [theme.breakpoints.down(770)]: {
            "#product-wrapper_component": {
                minHeight: "55vh !important",
                display: "flex",
            },
        },
        [theme.breakpoints.down(475)]: {
            ".product-wrapper-header .MuiTabs-root": {
                position: "fixed",
                backgroundColor: "white",
                zIndex: 2,
                width: '100%'
            },
        },
    };
});
export const ProductCardWrapper = (props) => {
    var _a, _b, _c;
    const [value, setValue] = React.useState(props.defaultTab || 0);
    const theme = useTheme();
    const showText = useMediaQuery(theme.breakpoints.up("md"));
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        setValue((prevState) => { var _a; return (_a = props.defaultTab) !== null && _a !== void 0 ? _a : prevState; });
    }, [props.defaultTab]);
    return (React.createElement(StyleWrapper, null,
        React.createElement(Card, { variant: "outlined" },
            showText && props.title ? (React.createElement(CardHeader, { title: props.title, className: "product-wrapper_title" })) : null,
            React.createElement(CardContent, { className: "product-wrapper-header" },
                props.tabs.length ? (React.createElement(Tabs, { variant: "scrollable", scrollButtons: "auto", value: value, allowScrollButtonsMobile: true, onChange: handleChange }, props.tabs.map((tab) => {
                    var _a;
                    return (React.createElement(Tab, Object.assign({}, tab, { style: Object.assign(Object.assign({}, tab.style), { width: showText ? (_a = tab === null || tab === void 0 ? void 0 : tab.style) === null || _a === void 0 ? void 0 : _a.width : "auto" }) })));
                }))) : null,
                React.createElement("div", { id: "product-wrapper_component" },
                    React.createElement(props.Component, { tabInfo: props.tabs[value] }))),
            !showText &&
                ((_a = props.buttons) === null || _a === void 0 ? void 0 : _a.find(({ label }) => label === "REIMBURSEMENT REQUEST")) ? (React.createElement(CardActions, { className: "product-wrapper_footer" },
                React.createElement("div", { className: "btn-wrapper" }, (_b = props.buttons) === null || _b === void 0 ? void 0 : _b.map((btn) => (React.createElement(Button, Object.assign({}, btn))))))) : null,
            showText && (React.createElement(CardActions, { className: "product-wrapper_footer" },
                React.createElement("div", { className: "btn-wrapper" }, (_c = props.buttons) === null || _c === void 0 ? void 0 : _c.map((btn) => (React.createElement(Button, Object.assign({}, btn))))),
                React.createElement("div", { className: "need-help-wrapper" },
                    props.footerText ? (React.createElement("div", null,
                        React.createElement("b", null, "Need help?"),
                        React.createElement("p", { className: "product-wrapper_footer-text", style: { marginTop: 0 }, dangerouslySetInnerHTML: { __html: props.footerText } }))) : null,
                    props.showChatIcon === false ? null : (React.createElement("div", { className: "product-wrapper_footer-chat" },
                        React.createElement(Fab, { "aria-label": "add", sx: { background: "#fb6647", color: "#fff", zIndex: 0 }, onClick: props.openChatMethod },
                            React.createElement(ForumIcon, { sx: { color: "#fff" } }))))))))));
};
